import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás con ardor o pesadez antes del primer mate y ya sabés cómo va a terminar el día.', 'Comés algo liviano y el reflujo o la hinchazón aparecen igual.', 'El omeprazol está en tu mesita de luz hace años y cada vez que intentás dejarlo, el fuego vuelve peor.', 'Te dijeron “es estrés”, “es la edad”… pero nadie explicó por qué sigue pasando.', 'Dejaste de disfrutar el asado y las reuniones por miedo a lo que viene después.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-79">
      <div className="mx-auto max-w-4xl" data-id="element-80">
        <header className="text-center" data-id="element-81">
          <h2 className="font-display font-bold sm:text-5xl text-[24px]" data-id="element-82">
            ¿Cuánto tiempo más vas a convivir con ese malestar que nadie supo
            explicarte?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-83">
            Sos una persona que se cuida. Buscás soluciones reales. Pero hasta
            ahora, nadie te dio la hoja de ruta correcta para tu cuerpo.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-84">
            No es falta de voluntad. Te faltaba el sistema correcto.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-85">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-86">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-87" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-88">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-89">
          ¿Y si pudieras dejar de sentirte así a partir de hoy?
        </p>
      </div>
    </section>;
}